// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardSelector_root__H9o_T","active":"DashboardSelector_active__1vka7"};